import { NgModule } from '@angular/core';
import { SharedModule } from '@ecip/shared';
import { UserRoutingModule } from './user-routing.module';
import { UserLocalComponent } from './local/local.component';
import { UserLocalEditComponent } from './local/edit/edit.component';
import { UserLocalViewComponent } from './local/view/view.component';
import { UserDeptComponent } from './dept/dept.component';
import { UserDeptEditComponent } from './dept/edit/edit.component';
import { UserDeptViewComponent } from './dept/view/view.component';
import {UserLocalRoleComponent} from "./local/role/user.role.component";
import {UserLocalAppComponent} from "./local/app/user.app.component";

const COMPONENTS = [
  UserLocalComponent,
  UserDeptComponent];
const COMPONENTS_NOROUNT = [
  UserLocalEditComponent,
  UserLocalViewComponent,
  UserDeptEditComponent,
  UserDeptViewComponent,
  UserLocalRoleComponent,
  UserLocalAppComponent];

@NgModule({
  imports: [
    SharedModule,
    UserRoutingModule
  ],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class UserModule { }
